// extracted by mini-css-extract-plugin
export default {"shareModalContent":"N0oM9UWXFBRhpIO26Yh7","shareTitle":"MlMfm8fpfAXQOcw67Wbq","shareModal":"mAx3_HG_wyzw3a84W_8D","shareIcon":"mYH_uRMXhcbfuFZ7TRjH"};